const ApproverInsightsReduser = (state = [], action) => {
    switch (action.type) {
        case 'APPROVER_INSIGHTS_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default ApproverInsightsReduser